export const FETCH_CAMERA = 'FETCH_CAMERA'
export const SET_CAMERA = 'SET_CAMERA'
export const CLEAR_CAMERA = 'CLEAR_CAMERA'
